import { createContext, useContext } from "react";

export enum ProgressStage {
  Default = "default",
  Processing = "processing",
  Success = "success",
  Error = "error",
}

interface FormContextInterface {
  progressStage: ProgressStage;
}

export const FormContext = createContext<FormContextInterface>({
  progressStage: ProgressStage.Default,
});

export const useFormContext = (): FormContextInterface =>
  useContext(FormContext);
